export default "__VITE_ASSET__CIoMQN$2__"